import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { GenericMenuItem } from '../../generic-menu/generic-menu-item.model';
import { GenericActionsComponent } from '../../generic-actions/generic-actions.component';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';

/**
 * This component is responsible for the display of standardized dialog content. Optionally, generic menu
 * items can be provided, which will be displayed inbetween the title and the close icon button.
 *
 * @export
 */
@Component({
  selector: 'hypecast-master-admin-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GenericActionsComponent, MatIconButton, MatTooltip, MatIcon, MatDivider],
})
export class DialogHeaderComponent {
  // This tooltip text will be displayed inside the tooltip of the close icon button
  readonly closeTooltipText = input<string>('Close the dialog');

  // Determines whether the divider should be visible or not
  readonly dividerIsVisible = input<boolean>(true);

  // These generic menu items will be displayed inbetween the title and the close icon button
  //  and migrating would break narrowing currently.
  readonly items = input<GenericMenuItem[]>([]);

  readonly title = input<string>('');

  readonly emitCloseClick = output<boolean>();
}
